(() => {
  const CLASS_HEAD = 'exposant';      // pour h1..h5
  const CLASS_OTHER = 'exposant-2';   // ailleurs (© seulement)
  const EXCLUDED = new Set(['SCRIPT','STYLE','TEXTAREA','CODE','PRE','NOSCRIPT','SVG','MATH']);
  const HEADING_CLASSNAMES = new Set(['h1','h2','h3','h4','h5', 'h6']); // si vos titres sont des <div class="h2"> etc.

  // Détermine si un node est (ou est dans) un titre h1..h5 ou .h1..h5
  function isInHeading(node){
    for (let n = node; n && n.nodeType === 1; n = n.parentNode){
      const tag = n.tagName;
      if (tag && /^H[1-6]$/.test(tag)) return true;
      if (n.classList){
        for (const c of HEADING_CLASSNAMES){ if (n.classList.contains(c)) return true; }
      }
    }
    return false;
  }

  function isExcluded(node){
    for (let n = node; n && n.nodeType === 1; n = n.parentNode){
      if (EXCLUDED.has(n.nodeName)) return true;
      if (n.classList && (n.classList.contains(CLASS_HEAD) || n.classList.contains(CLASS_OTHER))) return true; // évite le double wrap
    }
    return false;
  }

  // Enveloppe © et/ou * selon le contexte (titre vs. texte courant)
  function wrapSymbolsInTextNode(textNode){
    const txt = textNode.nodeValue;
    if (!txt) return;
    // Vite-fait : s'il n'y a ni © ni *, on sort
    // && txt.indexOf('*') === -1
    if (txt.indexOf('©') === -1 && txt.indexOf('®') === -1) return;

    const inHeading = isInHeading(textNode.parentNode);
    // *
    const re = /[©®]/g; // on scanne les deux, on décidera au cas par cas
    let m, last = 0;
    const frag = document.createDocumentFragment();

    while ((m = re.exec(txt))){
      const ch = m[0];
      // tronçon avant le symbole
      if (m.index > last) frag.appendChild(document.createTextNode(txt.slice(last, m.index)));

      if (inHeading){
        // Dans les titres : on wrap © ET *
        const span = document.createElement('span');
        span.className = CLASS_HEAD;
        span.textContent = ch;
        frag.appendChild(span);
      } else {
        // Hors titres : on wrap UNIQUEMENT © ; on laisse * tel quel
        if (ch === '©'){
          const span = document.createElement('span');
          span.className = CLASS_OTHER;
          span.textContent = ch;
          frag.appendChild(span);
        } else {
          frag.appendChild(document.createTextNode(ch));
        }
      }
      last = m.index + 1;
    }
    // reste de la chaîne
    if (last < txt.length) frag.appendChild(document.createTextNode(txt.slice(last)));
    textNode.parentNode.replaceChild(frag, textNode);
  }

  function walk(root){
    const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node){
        if (isExcluded(node.parentNode)) return NodeFilter.FILTER_REJECT;
        const v = node.nodeValue;
        //  || v.indexOf('*') !== -1 
        return (v && (v.indexOf('©') !== -1 || v.indexOf('®') !== -1))
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_SKIP;
      }
    });
    const batch = [];
    while (tw.nextNode()) batch.push(tw.currentNode);
    batch.forEach(wrapSymbolsInTextNode);
  }

  // 1er passage
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', () => walk(document.body), { once: true });
  } else {
    walk(document.body);
  }

  // MutationObserver (optionnel) — surveille les ajouts/edits
  const mo = new MutationObserver(muts => {
    for (const m of muts){
      if (m.type === 'characterData' && m.target.nodeType === 3){
        if (!isExcluded(m.target.parentNode)) wrapSymbolsInTextNode(m.target);
      } else if (m.addedNodes && m.addedNodes.length){
        m.addedNodes.forEach(n => {
          if (n.nodeType === 3) wrapSymbolsInTextNode(n);
          else if (n.nodeType === 1 && !isExcluded(n)) walk(n);
        });
      }
    }
  });
  mo.observe(document.body, { subtree: true, childList: true, characterData: true });
})();
